<!--
 * @Author: your name
 * @Date: 2020-06-10 15:44:18
 * @LastEditTime: 2020-06-10 16:44:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \esign-landing\src\views\common\components\h5\BottomBtn.vue
-->
<template>
  <div class="btn_bottom">
    <PhoneDialog :dialogVisible.sync="dialogVisible" />
    <div class="icon-btn" @click="phoneClick">
      <div>
        <img :src="require('@/assets/images/icon-phone.svg')" alt="" class="icon" />
      </div>
      <div class="icon-btn__name">电话咨询</div>
    </div>
    <!-- 百度爱番番客服 -->
    <a
      v-if="$route.path === '/landing/semtel'"
      class="icon-btn"
      href="https://p.qiao.baidu.com/cps/chat?siteId=17892016&userId=6152131&siteToken=032041ad2a9e476410424bbb8779fa36"
      target="_blank"
    >
      <div>
        <img :src="require('@/assets/images/icon-headphone.svg')" alt="" class="icon" />
      </div>
      <div class="icon-btn__name">客服咨询</div>
    </a>
    <!-- 七鱼客服 -->
    <div v-else class="icon-btn" @click="handleCustomerServiceClick">
      <div>
        <img :src="require('@/assets/images/icon-headphone.svg')" alt="" class="icon" />
      </div>
      <div class="icon-btn__name">客服咨询</div>
    </div>
    <div class="submit-btn" @click="$emit('click')">
      <img :src="require('@/assets/images/icon-submit-btn.svg')" alt="submit" />
      <span>申请免费试用</span>
    </div>
  </div>
</template>

<script>
import qiyuMixin from '../mixins/qiyu.js'

export default {
  mixins: [qiyuMixin],
  components: {
    PhoneDialog: () => import('./PhoneDialog.vue'),
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  props: {
    title: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.addQiyuScript()
  },
  methods: {
    phoneClick() {
      // TODO:
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.btn_bottom {
  width: 100%;
  height: 58px;
  border-top: 1px solid #e5e5e5;
  position: fixed;
  bottom: 0;
  background: #fff;
  z-index: 9;
  display: flex;
  justify-content: space-between;
  padding: 7px 7px 7px 30px;

  .submit-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 170px;
    height: 43px;
    background: #e61717;
    font-size: 12px;
    color: #fff;
    border-radius: 3px;
    padding: 0 30px;

    img {
      width: 30px;
    }
  }

  .icon-btn {
    display: inline-block;

    img {
      width: 30px;
      height: 30px;
      margin: 0 auto;
    }

    &__name {
      font-size: 10px;
    }
  }
}
</style>
